<template>
  <div>
  	<el-container>
  		<el-main>
  			<el-row :gutter="20">
		  		<el-col :span="12" :offset="6">
		  			<div class="auth-header">
		  				<img src="../../assets/logo.png">
		  			</div>
		  			<div class="signup-body auth-panel">
              <h1 style="margin:0 auto; padding-top:20px; color:#666;">Password Reset</h1>
		  				<el-form ref="form" class="auth-form"  label-position="top" label-width="100px" :model="userData">
                <div v-if="!requested">
	                <el-form-item prop="email" label="Email">
	                  <el-input placeholder="john.doe@wza.com" v-model="userData.email"></el-input>
	                </el-form-item>
	              
	                <el-button @click.native="requestPasswordReset" :loading="savingData" type="primary">Request Password Reset</el-button>
               </div>
               <div v-else>
               		<h3 style="color:#555;">An email with your password reset link has been sent.</h3>
               </div>
                <a class="to-login" href="#/login">Back to login</a>
              </el-form>
		  			</div>
		  		</el-col>
			</el-row>
  		</el-main>
	</el-container>
  </div>
</template>
<script>

export default {
  name: 'forgot',
  data () {
    return {
      requested: false,
      savingData: false,
      msg: 'This is the login',
      userData:{
        email:"",
        password:""
      }
    }
  },
  methods:{
    requestPasswordReset:function(){
      var _this = this;
      _this.savingData = true;
      var email = this.userData.email;
      if(email) email = email.trim().toLowerCase();
      Parse.Cloud.run('resetPassword', {'email':email})
        .then(function(user){
          console.log("Reset Requested")
          _this.requested = true;
        }).catch(function(error){
          _this.savingData = false;
          _this.requested = true;
           _this.$message.error(error);
        })

//             Parse.User.requestPasswordReset("juan@coach-hq.com", {
//   success: function() {
//   // Password reset request was sent successfully
//   		_this.savingData = false;
//   		 console.log("Reset Requested")
//           _this.requested = true;
//   },
//   error: function(error) {
//     _this.savingData = false;
//       _this.requested = true;
//        _this.$message.error(error);
//     alert("Error: " + error.code + " " + error.message);
//   }
// });
    },
    goToSignup:function(){
      this.$router.push('/signup/plan');
    }
  }
}
</script>

<style>

</style>
